import { Label } from '@/components/ui/label'
import { ImageUploadField } from '@/components/ui/image-upload-field'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Button } from '@/components/ui/button'
import { useProfile, type ProfileData } from '@/hooks/use-profile'
import {
  ArtifactCanvasBody,
  ArtifactCanvasFooterBar,
} from '@/components/artifact/artifact-canvas-layout'

interface ProfileBannerCanvasProps {
  profile: ProfileData
  onClose: () => void
}

export function ProfileBannerCanvas({ profile, onClose }: ProfileBannerCanvasProps) {
  const {
    profile: latestProfile,
    uploadBanner,
    deleteBanner,
    isUploadingBanner,
    isDeletingBanner,
    uploadBannerError,
  } = useProfile()
  const currentProfile = latestProfile ?? profile

  return (
    <ArtifactCanvasBody className="flex h-full min-h-0 flex-col space-y-0 p-0">
      <ScrollArea className="min-h-0 flex-1">
        <ArtifactCanvasBody className="space-y-6">
          <div className="space-y-2">
            <Label>Cover image</Label>
            <ImageUploadField
              variant="banner"
              serverImageUrl={currentProfile.banner_url}
              uploadBanner={uploadBanner}
              deleteBanner={deleteBanner}
              isUploadingBanner={isUploadingBanner}
              isDeletingBanner={isDeletingBanner}
              persistenceNote={null}
            />
            <p className={`text-xs ${uploadBannerError ? 'text-destructive' : 'text-muted-foreground'}`}>
              {uploadBannerError instanceof Error
                ? uploadBannerError.message
                : uploadBannerError
                  ? String(uploadBannerError)
                  : 'Choose an image to upload (PNG, JPEG, GIF, or WebP; max 5 MB). It saves when selected.'}
            </p>
          </div>
        </ArtifactCanvasBody>
      </ScrollArea>
      <ArtifactCanvasFooterBar
        actions={
          <Button type="button" variant="outline" onClick={onClose}>
            Close
          </Button>
        }
      />
    </ArtifactCanvasBody>
  )
}
